import { ArrowRight } from '@untitledui/icons';
import React, { useCallback } from 'react';
import { Button as AriaButton } from 'react-aria-components';

import { Dropdown } from '@/lib/base/overlays/dropdown';

import type { GroupSummary } from './shared';

interface MoveConditionMenuProps {
  conditionId: string;
  otherGroups: GroupSummary[];
  onMove: (conditionId: string, targetGroupId: string) => void;
}

/**
 * Per-row menu (rendered outside FilterConditionRow) offering every other
 * group as a move target for this condition.
 */
export const MoveConditionMenu = React.memo(function MoveConditionMenu({
  conditionId,
  otherGroups,
  onMove,
}: MoveConditionMenuProps) {
  const handleAction = useCallback(
    (key: React.Key) => onMove(conditionId, String(key)),
    [conditionId, onMove]
  );

  return (
    <Dropdown.Root>
      <AriaButton
        aria-label='Move condition to another group'
        data-component='move-condition-menu'
        className='p-1 mt-2 rounded-md transition-colors text-secondary hover:bg-bg-secondary_hover hover:text-primary shrink-0 cursor-pointer'
      >
        <ArrowRight className='w-4 h-4' />
      </AriaButton>
      <Dropdown.Popover placement='bottom end'>
        <Dropdown.Menu onAction={handleAction}>
          {otherGroups.map(group => (
            <Dropdown.Item key={group.id} id={group.id}>
              {/* Self-explanatory outside the trigger's context — the items
                  are the only text the user sees once the menu is open. */}
              Move to {group.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown.Root>
  );
});
